import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import { Route, Switch, Link, Redirect } from 'react-router-dom'

import {actions as categoriesActions} from '../../redux/modules/Categories'
import RegistrationSplashContainer from './Splash/RegistrationSplashContainer'
import RegistrationUserInfoContainer from './UserInfo/RegistrationUserInfoContainer'
import Breadcrumbs from '../../components/BreadCrumbs/Breadcrumbs'

import './Registration.css'

import * as authActions from '../../actions/auth'
import RegistrationMarkContainer from './Mark/RegistrationMarkContainer'
import RegistrationWorkerSplashContainer from './WorkerSplash/RegistrationWorkerSplashContainer'
import RegistrationCompleted from './RegistrationCompleted/RegistrationCompleted'
import RegistrationEmailConfirmed from './RegistrationEmailConfirmed/RegistrationEmailConfirmed'
import RegistrationCategoriesChooser from './RegistrationCategoriesChooser'
import CategoryNameBreacrumb from '../../components/BreadCrumbs/CategoryNameBreacrumb'

const mapStateToProps = (state) => {
  return {
    state: state.auth,
    categories: state.categories,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(authActions, dispatch),
    categoriesActions: bindActionCreators(categoriesActions, dispatch)
  }
}

const routes = {
  '/': 'Home',
  '/register': 'Registrazione',
  '/register/choose-category': 'Seleziona Categoria',
  '/register/choose-category/:id': ({id}) => <CategoryNameBreacrumb id={id} />,
  '/register/user-info': 'Informazioni Utente',
  '/register/user-info/:id': ({id}) => <CategoryNameBreacrumb id={id} />
}

class RegistrationContainer extends Component {
  static propTypes = {
    match: PropTypes.object
  }

  getCategoryByName (category) {
    let data = this.props.categories.data.filter(item => category === item.name)
    if (data.length === 0) {
      return null
    }
    return data[0]
  }

  componentWillMount () {
    this.props.categoriesActions.fetchCategories()
  }

  render () {
    const { match } = this.props

    console.log(match.url)
    if (this.props.categories.loading) {
      return (<div>Caricamento in Corso...</div>)
    }

    return (
      <div>
        <div className="row">
          <div
            className="col-md-8 col-md-push-2"
            style={{paddingTop: 10, paddingBottom: 10, margin: '0 auto', textAlign: 'center'}}>
            <Breadcrumbs routes={routes} />
          </div>
        </div>

        <Switch>
          <Route path="/register/completed" component={RegistrationCompleted} />
          <Route path="/register/confirmMail" component={RegistrationEmailConfirmed} />
          <Route path={match.url + '/user-info/:categoryId'} component={RegistrationUserInfoContainer} />
          <Route path={match.url + '/choose-category/:id'} component={RegistrationCategoriesChooser} />
          <Route path={match.url + '/choose-category'} component={RegistrationCategoriesChooser} />
          <Redirect to={match.url + '/choose-category'} />
        </Switch>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationContainer)



// WEBPACK FOOTER //
// ./src/containers/Registration/RegistrationContainer.js